import React from "react";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { connect } from "react-redux";

import notificationsStyle from "../../../assets/jss/material-dashboard-pro-react/views/notificationsStyle.tsx";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "../../../components/CustomButtons/Button";
import DialogContent from "@mui/material/DialogContent";
import CustomInput from "../../../components/CustomInput/CustomInput";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";

import { Close } from "@mui/icons-material";
import { FormLabel } from "@mui/material";
import GridItem from "../../../components/Grid/GridItem";
import GridContainer from "../../../components/Grid/GridContainer";
import SaveButton from "../../../components/CustomInput/SaveButton";
import * as actions from "../../../store/actions";

import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { toast } from "react-toastify";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction={"down"} ref={ref} {...props} />;
});

class Testmail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sendingCustomerinvoice: false,
      sendingSalesinvoice: false,
      to_mail: "",
    };
  }

  sent = (type) => {
    switch (type) {
      case "customerinvoice":
        this.setState({ sendingCustomerinvoice: true });
        break;
      case "salesinvoice":
        this.setState({ sendingSalesinvoice: true });
        break;
    }

    let data = {
      to_mail: this.state.to_mail,
      type: type,
    };

    axios.post("/core/vestigingen/" + this.props.vestiging_id + "/senttestmail", data).then((response) => {
      switch (type) {
        case "customerinvoice":
          this.setState({ sendingCustomerinvoice: false });
          break;
        case "salesinvoice":
          this.setState({ sendingSalesinvoice: false });
          break;
      }

      if (response.data.data.success) {
        toast.success(response.data.data.message);
      } else {
        this.setState({
          sendingCustomerinvoice: false,
          sendingSalesinvoice: false,
        });
        toast.error(response.data.data.message);
      }
    });
  };

  disableSent = () => {
    return this.state.to_mail === "";
  };

  handleEmailchange = (event) => {
    this.setState({ to_mail: event.target.value });
  };

  render() {
    const { classes } = this.props;

    return (
      <Dialog
        TransitionComponent={Transition}
        aria-describedby={"notice-modal-slide-description"}
        aria-labelledby={"notice-modal-slide-title"}
        fullWidth
        keepMounted
        maxWidth={"lg"}
        onClose={this.props.toggle}
        open={this.props.open}
      >
        <DialogTitle className={classes.modalHeader} disableTypography id={"notice-modal-slide-title"}>
          <Button
            aria-label={"Close"}
            className={classes.modalCloseButton}
            color={"transparent"}
            justIcon
            key={"close"}
            onClick={this.props.toggle}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>
            <TranslationWrapper tDefault={"Verstuur een test email"} tKey={"vestigingen.modal.testmail.title"} />
          </h4>
        </DialogTitle>
        <DialogContent className={classes.modalBody} id={"notice-modal-slide-description"}>
          <GridContainer>
            <GridItem sm={2} xs={12}>
              <FormLabel className={classes.labelHorizontal}>
                <TranslationWrapper tDefault={"Verstuur naar"} tKey={"vestigingen.modal.testmail.form.email"} />
              </FormLabel>
            </GridItem>
            <GridItem sm={10} xs={12}>
              <CustomInput
                formControlProps={{
                  fullWidth: true,
                }}
                id={"email"}
                inputProps={{
                  type: "text",
                  name: "naam",
                  onChange: this.handleEmailchange,
                }}
              />
            </GridItem>
          </GridContainer>
        </DialogContent>

        <DialogActions className={classes.modalFooter + " " + classes.modalFooterCenter}>
          <SaveButton
            buttonText={
              <TranslationWrapper
                tDefault={"Verstuur naar"}
                tKey={"vestigingen.modal.testmail.form.customerEmailText"}
              />
            }
            disabled={this.disableSent()}
            onClick={() => this.sent("customerinvoice")}
            saving={this.state.sendingCustomerinvoice}
          />
          <SaveButton
            buttonText={
              <TranslationWrapper tDefault={"Ticket mail"} tKey={"vestigingen.modal.testmail.form.ticketEmailText"} />
            }
            disabled={this.disableSent()}
            onClick={() => this.sent("salesinvoice")}
            saving={this.state.sendingSalesinvoice}
          />
        </DialogActions>
      </Dialog>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    showMessage: (message) => dispatch({ type: actions.SHOW_MESSAGE, message: message }),
    closeMessage: () => dispatch({ type: actions.CLOSE_MESSAGE }),
  };
};

export default connect(mapDispatchToProps)(withStyles(Testmail, notificationsStyle));
